import React from 'react'

function OurPartner() {
  return (
    <div>
      <div className="partner-style-two-area default-padding bg-dark text-light">
  <div className="container">
    <div className="row">
      {/* Single Item */}
      <div className="col-lg-6 partner-style-one">
        <div
          className="partner-style-one-item bg-theme text-light"
          style={{ backgroundImage: "url(static/img/shape/22.png)" }}
        >
          <h4 className="sub-title">Our Partners</h4>
          <h2 className="title">
            Worked with <br /> Largest Brands
          </h2>
        </div>
      </div>
      {/* End Single Item */}
      {/* Single Item */}
      <div className="col-lg-3 col-md-6 partner-style-one">
        <div className="partner-style-one-item wow fadeInLeft">
          <img src="static/img/brand/11.png" alt="Img Not Found" />
        </div>
      </div>
      {/* End Single Item */}
      {/* Single Item */}
      <div className="col-lg-3 col-md-6 partner-style-one">
        <div
          className="partner-style-one-item wow fadeInLeft"
          data-wow-delay="200ms"
        >
          <img src="static/img/brand/22.png" alt="Img Not Found" />
        </div>
      </div>
      {/* End Single Item */}
      {/* Single Item */}
      <div className="col-lg-3 col-md-6 partner-style-one">
        <div
          className="partner-style-one-item wow fadeInLeft"
          data-wow-delay="300ms"
        >
          <img src="static/img/brand/33.png" alt="Img Not Found" />
        </div>
      </div>
      {/* End Single Item */}
      {/* Single Item */}
      <div className="col-lg-3 col-md-6 partner-style-one">
        <div
          className="partner-style-one-item wow fadeInLeft"
          data-wow-delay="400ms"
        >
          <img src="static/img/brand/44.png" alt="Img Not Found" />
        </div>
      </div>
      {/* End Single Item */}
      {/* Single Item */}
      <div className="col-lg-3 col-md-6 partner-style-one">
        <div
          className="partner-style-one-item wow fadeInLeft"
          data-wow-delay="500ms"
        >
          <img src="static/img/brand/55.png" alt="Img Not Found" />
        </div>
      </div>
      {/* End Single Item */}
      {/* Single Item */}
      <div className="col-lg-3 col-md-6 partner-style-one">
        <div
          className="partner-style-one-item wow fadeInLeft"
          data-wow-delay="600ms"
        >
          <img src="static/img/brand/66.png" alt="Img Not Found" />
        </div>
      </div>
      {/* End Single Item */}
    </div>
  </div>
</div>

    </div>
  )
}

export default OurPartner
